import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import * as tutorialUtils from "../../../../abstract/controller/utils/tutorialUtils";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";

const id = "label2";
const idNext = "label3";
const idPrev = "label1";

const next = `
global parameters:
  - parameter: weapon
    choices:
      - choice: sword
      - choice: dagger
      - choice: axe
      - choice: mace
      - choice: crossbow
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - linked parameter: hero weapon
        linked to: weapon
      - parameter: foe
        choices:
          - choice: witch
            labels:
              - easy
          - choice: cyclops
          - choice: giant
      - linked parameter: foe weapon
        linked to: weapon
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
            labels:
              - easy
          - choice: mountain
          - choice: lake
            labels:
              - easy
    logic:
      - constraint: Peter fights only easy foes in easy locations
        expression: "'hero' IS 'Peter' => ('foe' LABEL IS 'easy' AND 'location' LABEL IS 'easy')"
`;

const prev = `
global parameters:
  - parameter: weapon
    choices:
      - choice: sword
      - choice: dagger
      - choice: axe
      - choice: mace
      - choice: crossbow
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - linked parameter: hero weapon
        linked to: weapon
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - linked parameter: foe weapon
        linked to: weapon
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
`;

function ManualLabels2({ tutorial, setTutorial }) {
  if (tutorial === id) {
    return <Core setTutorial={setTutorial} />;
  }

  return null;
}

function Core({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(next);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(prev);
    _dispatch(setRoot(model, 0));
    setTutorial(idPrev);
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("header_logic") && !document.getElementById("logic_constraint") && (
        <div className={`${styles["container"]} ${styles["container-label2"]} ${styles["overlay"]}`}>
          <div id="tutorial-text-label2" className={`${styles["container__text"]}`}>
            <p>To show/hide logic click on the header.</p>
          </div>

          <Xarrow
            key={`arrow-1-${renderTrigger}`}
            start="tutorial-text-label2"
            end="header_logic"
            color="#415B32"
            strokeWidth={2}
            path="smooth"
            curveness={0.8}
            headSize={6}
          />
        </div>
      )}

      <div className={`${styles["foreground"]} ${styles["foreground-label2"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Now, create a constraint saying that Peter is is still a trainee and is allowed to fight easy monsters in easy terrain.
            </p>
            <p>
              The name should be <b>Peter fights only easy foes in easy locations</b> and the expression: <b>'hero' IS 'Peter' =&gt; ('foe' LABEL IS 'easy' AND 'location' LABEL IS 'easy')</b>.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export const manualValidateLabels2 = (root, tutorial, setTutorial, setMessage) => {
  if (tutorial === id) {
    let { res: resFun, msg: msgFun } = tutorialUtils.validateSingleFunction(root);

    if (!resFun) {
      setMessage(msgFun);
      return false;
    }

    let { res: resLogic, msg: msgLogic } = tutorialUtils.validateCondition(
          root,
          "root→[function]→simple→[logic]→Peter fights only easy foes in easy locations",
          "'hero' IS 'Peter' => ('foe' LABEL IS 'easy' AND 'location' LABEL IS 'easy')",
        );
    
        if (!resLogic) {
          setMessage(msgLogic);
          return false;
        }

    setTutorial(idNext);

    setMessage("");
    return true;
  }

  return false;
};

export default ManualLabels2;
